// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"fcc0123d","409":"1d41cdb5","453":"1fe6c1e1"}[chunkId] + ".chunk.js";
};